import axios from 'axios';
import { getBackendBaseUrl } from './apiUrls';

export function surveysApiRoot() {
    return `${getBackendBaseUrl()}/surveys`;
}

export async function fetchCancellationSurvey(token) {
    const res = await axios.get(`${surveysApiRoot()}/sessions/${token}`);
    return res.data;
}

export async function saveCancellationSurveyAnswer(token, payload) {
    const res = await axios.post(`${surveysApiRoot()}/sessions/${token}/answers`, payload);
    return res.data;
}

export async function completeCancellationSurvey(token) {
    const res = await axios.post(`${surveysApiRoot()}/sessions/${token}/complete`);
    return res.data;
}

export function surveyRequestIsAlreadyComplete(err) {
    return err?.response?.data?.error === 'completed' || err?.response?.status === 409;
}

export function surveyRequestErrorMessage(err) {
    const data = err?.response?.data || {};
    if (surveyRequestIsAlreadyComplete(err)) {
        return (
            data.message
            || "You've already submitted this survey. Thank you for your feedback. You can close this page."
        );
    }
    return data.message || data.error || err?.message || 'Something went wrong. Please try again.';
}

function answerIsMissing(question, answers) {
    if (!answers || !Object.prototype.hasOwnProperty.call(answers, question.key)) {
        return true;
    }
    const saved = answers[question.key];
    if (saved == null) return true;
    if (!question.required) return false;
    return saved.value == null || saved.value === '' || (Array.isArray(saved.value) && !saved.value.length);
}

export function firstUnansweredIndex(questions, answers) {
    if (!Array.isArray(questions)) return 0;
    const idx = questions.findIndex((q) => answerIsMissing(q, answers));
    if (idx >= 0) return idx;
    return Math.max(0, questions.length - 1);
}
